import { Icon, TimelineItem } from '@ps/isp-web-component-library';
import { Ninety } from '@ps/isp-web-component-library/icons/Ninety';
import { StarSubIcon } from '@ps/isp-web-component-library/icons/StarSubIcon';
import { TwoUpIcon } from '@ps/isp-web-component-library/icons/TwoUpIcon';
import { type MarketId, type SelectionId } from '@ps/isp-web-services-types';
import { getIsMatchOddsNinetyMarket, getIsTwoUpMarket } from '@ps/web-sports-utils';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';
import { getHandicapSelectionValue } from '@swf/sports/utils/getHandicapSelectionValue';

import {
  TXTWCL_Match_Odds_90,
  TXTWCL_Match_Odds___2_Up,
  TXTWCL_Star_Sub_enabled_selection
} from './PopularBetBuilderItem.messages.json';
import styles from './PopularBetBuilderItem.scss';

interface Props {
  marketId: MarketId;
  selectionId: SelectionId;
}

const PopularBetBuilderItem: React.FC<Props> = ({ marketId, selectionId }: Props) => {
  const { market } = useNormalisedEventBasedData({ marketId });
  const { formatMessage } = useRegulatoryIntl();

  const runner = market?.runners.find((runner) => runner.selectionId === selectionId);
  const isMatchOddsNinetyMarket = getIsMatchOddsNinetyMarket(market?.marketType);
  const isTwoUpMarket = getIsTwoUpMarket(market?.marketType);

  if (!market || !runner) return null;

  const { runnerName, handicap, resultType } = runner;
  const handicapValue = getHandicapSelectionValue({
    handicap,
    runnerResultType: resultType
  });

  return (
    <TimelineItem textWrap="balance">
      <span className={styles.runnerName}>
        {runnerName} {handicapValue ? `(${handicapValue})` : null}
      </span>{' '}
      - {market.marketName}
      {market.isStarSubEnabled && (
        <Icon
          icon={StarSubIcon}
          className={styles.marketIcon}
          label={formatMessage(TXTWCL_Star_Sub_enabled_selection)}
          size="xs"
        />
      )}
      {isMatchOddsNinetyMarket ? (
        <Icon
          icon={Ninety}
          className={styles.marketIcon}
          label={formatMessage(TXTWCL_Match_Odds_90)}
          size="xs"
        />
      ) : null}
      {isTwoUpMarket ? (
        <Icon
          icon={TwoUpIcon}
          className={styles.marketIcon}
          label={formatMessage(TXTWCL_Match_Odds___2_Up)}
          size="xs"
        />
      ) : null}
    </TimelineItem>
  );
};

export default PopularBetBuilderItem;
